import { makeStyles, Text, Divider } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useIsV2 } from '@data';

const useStyles = makeStyles({
  header: {
    padding: '16px',
  },
  title: {
    color: '#14141E',
  },
});

export const Header = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const isV2 = useIsV2();

  if (isV2) return null;
  return (
    <>
      <header className={styles.header}>
        <Text className={styles.title} weight="bold" size={300} role="heading">
          {t('header.title')}
        </Text>
      </header>
      <Divider />
    </>
  );
};
